import React, { Component } from 'react';
import { Info } from 'react-feather';
import { PromptsENG } from './NavPrompts';


class NavBar extends Component {
  render() {
    return (
      <nav className='navbar navbar-expand-lg navbar-light bg-light py-0'
      style={{ borderBottom: "5px solid #009edb" }}>

        
          <a className="brand-bar ml-2" href="https://un.org/en">Welcome to the United Nations</a>
        

        <button
          className='navbar-toggler ms-auto'
          type='button'
          data-toggle='collapse'
          data-target='#navbarTogglerDemo02'
          aria-controls='navbarTogglerDemo02'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon'></span>
        </button>
		
		
        <div className='collapse navbar-collapse' id='navbarTogglerDemo02'>
          {/* <div className="col-md-4">
          <a className="brand-bar" href="https://un.org/en">Welcome to the United Nations</a>
          </div> */}
          <div className='mr-auto'></div>
          <ul className='navbar-nav ms-auto'>

	
		
            <li className='nav-item'>
              <a className='nav-link small' href='/ARB'>
                العربية
              </a>
            </li>
            <li className='nav-item'>
              <a className='nav-link small' href='/CHN'>
                中文
              </a>
            </li>
            <li className='nav-item'>
              <a className='nav-link small' href='/ENG'>
                English
              </a>
            </li>
            <li className='nav-item'>
              <a className='nav-link small' href='/FRE'>
                Français
              </a>
            </li>
            <li className='nav-item'>
              <a className='nav-link small' href='/RUS'>
                Русский
              </a>
            </li>
            <li className='nav-item'>
              <a className='nav-link small' href='/ESP'>
                Español
              </a>
            </li>

            <a className='navbar-brand text-secondary pt-1 pb-1 pl-3' data-toggle='modal' data-target='#aboutUs'>
            {/* <HelpCircle width='15px' height='15px' strokeWidth='2' enableBackground='true' /> */}
            <Info width='15px' height='15px' strokeWidth='2' enableBackground='true' />
          </a>
          </ul>
          
            <div className='modal fade' id='aboutUs' tabIndex='-1'>
          {/* <div className='modal fade' id='aboutUs'> */}
            <div className='modal-dialog aboutUsModal'>
              <div    //model content start
                style={{
                      borderLeft: "5px solid #009edb",
                      width: "75%",
                      margin: "0 auto",
                  }}
                className='modal-content'>
		
                <div 
                  // style={{
                  //     borderTop: "5px solid #009edb",
                  // }}
                
                className='modal-header aboutUsHeader pt-0 pb-2'>
                  <h6 
                    style={{
                      color: "#404040",
                      backgroundColor: "#ffffff",
                      borderBottom: "none",
                      marginLeft: '30px',
                      borderBottom: "3px solid #009edb",
                      fontFamily: "'Roboto Condensed', Arial, sans-serif",
                      fontSize: '26px',
                      letterSpacing: '0px',
                      opacity: 1,
                      fontWeight: 700}}
                    className='modal-title mt-2' id='aboutUs'>
                      {/* <strong>{PromptsENG.aboutUsTitle}</strong> */}
                    {PromptsENG.aboutUsTitle}
                  </h6>
                  <button 
                  style={{ 
                    paddingTop: '0px',
                    paddingBottom: '0px',
                  }}
                  // type='button' className='close' data-dismiss='modal' aria-label='Close'>
                  type='button' className='close close-popup' data-dismiss='modal' aria-label='Close'>
                    <span aria-hidden='true'>&times;</span>
                  </button>
                </div>
					
                {/* <div className='modal-body'>
                  <p className='text-secondary'>
                    {PromptsENG.aboutUs1}
                    <strong>
                      {PromptsENG.aboutUs2}
                    </strong>
                    {PromptsENG.aboutUs3}
                  </p>
                  <p className='text-secondary'>{PromptsENG.aboutUs4}</p>
                  <p className='text-secondary'>{PromptsENG.aboutUs5}</p>
                  <p className='text-secondary'>{PromptsENG.aboutUs6}</p>
                </div> */}

                            <div
                              style={{
                                // width: '700px',
                                // height: 'px', 
                                // background: '#F5f5f5',
                        
                                display: 'flex',
                                alignItems: 'stretch',
                                //padding: '0 0 0 12px',  // space for vertical line
                                boxSizing: 'border-box',
                                overflowY: 'auto',        // vertical scroll if content exceeds height
                                // marginTop: '20px',
                                marginLeft: '40px',
                                marginRight: '40px',
                                marginBottom: '20px',
                  
                              }}
                              >
                              {/* Vertical line */}
                              {/* <div
                                style={{
                                  width: '4px',
                                  backgroundColor: '#009EDB',
                                  marginRight: '12px',
                                  flexShrink: 0,
                                }}
                              ></div> */}
                
                              {/* Text content */}
                              <div style={{ display: 'flex', flexDirection: 'column', flex: 1  }}>
                                {/* Caption text */}
                                <p
                                  className='my-0 map-caption'
                                  style={{
                                    fontSize: '16px',
                                    marginRight: '40px',
                                    marginLeft: '5px',
                                    // paddingTop: '20px',
                                    // paddingRight: '20px',
                                    paddingBottom: '20px',
                                    lineHeight: '24px', 
                                    // fontFamily: "'Roboto'",
                                    letterSpacing: '0px',
                                    fontWeight: 400,
                                    opacity: 1,
                                    //font: 'normal normal normal 8px/12px Roboto',
                                    color: '#404040',//'#8c8c8c',
                                    // color: '#cdcdcd',
                                    // letterSpacing: '0.5px',
                                    // lineHeight: '1.2',
                                  }}
                                  >
                                  {/* {CaptionENG} */}
                                  {PromptsENG.aboutUs1}
                                  <strong>
                                  {PromptsENG.aboutUs2}
                                  </strong>
                                  {PromptsENG.aboutUs3}
                                </p>
                                {/* Caption text */}
                                <p
                                  className='my-0 map-caption'
                                  style={{
                                    fontSize: '16px',
                                    marginRight: '40px',
                                    marginLeft: '5px',
                                    // paddingTop: '20px',
                                    // paddingRight: '20px',
                                    paddingBottom: '20px',
                                    lineHeight: '24px', 
                                    fontFamily: "'Roboto'",
                                    letterSpacing: '0px',
                                    fontWeight: 400,
                                    opacity: 1,
                                    //font: 'normal normal normal 8px/12px Roboto',
                                    color: '#404040',//'#8c8c8c',
                                    // color: '#cdcdcd',
                                    // letterSpacing: '0.5px',
                                    // lineHeight: '1.2',
                                  }}
                                  >
                                  {/* {CaptionENG} */}
                                  {PromptsENG.aboutUs4}
                                </p>


                                <p
                                  className='my-0 map-caption'
                                  style={{
                                    fontSize: '16px',
                                    marginRight: '40px',
                                    marginLeft: '5px',
                                    // paddingTop: '20px',
                                    // paddingRight: '20px',
                                    paddingBottom: '20px',
                                    lineHeight: '24px', 
                                    fontFamily: "'Roboto'",
                                    letterSpacing: '0px',
                                    fontWeight: 400,
                                    opacity: 1,
                                    //font: 'normal normal normal 8px/12px Roboto',
                                    color: '#404040',//'#8c8c8c',
                                    // color: '#cdcdcd',
                                    // letterSpacing: '0.5px',
                                    // lineHeight: '1.2',
                                  }}
                                  >
                                  {/* {CaptionENG} */}
                                  {PromptsENG.aboutUs6}
                                </p>
                
                              </div>
                            </div>





					
              </div> {/* Model content end */}
            </div>
		      </div>
        </div>
      </nav>
    );
  }
}

export default NavBar;
